import { Injectable } from '@angular/core';
import {BaseDataService} from '../../../core/services/base-data.service';
import {Locations} from '../models/locations.model';
import {API_MAP} from '../../../core/helpers/api.map';
import {Observable, tap} from 'rxjs';
import {Result} from '../../../core/models/result';

@Injectable()
export class LocationsService extends BaseDataService<Locations>{
  override controller = API_MAP.locations;

  override get(controller?: string): Observable<Result<any>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }
}
